//////////////////////////////////////////////
//! PageController 
//////////////////////////////////////////////

PageController = function( dispatcher ) {

//--------------------------------------------
//! -- Static Vars --
//--------------------------------------------
	this.LANDING_PAGE_T = "landing_page";
	this.ENTER_NAME_PAGE_T = "enter_name";
	this.UPLOAD_PAGE_T = "add_photo";
	this.RESIZE_PAGE_T = "adjust_one";
	this.ADJUST_PAGE_T = "'adjust_two";
	this.SHARING_PAGE_T = "share_message";
	this.FACEBOOK_T = "share_facebook";
	this.FACEBOOK_T = "share_facebook";
	this.TWITTER_T = "share_twitter";
	this.DOWNLOAD_T = "download_image";

	this.LANDING_PAGE = "page--landing";
	this.ENTER_NAME_PAGE = "page--enterName";
	this.UPLOAD_PAGE = "page--uploadPhoto";
	this.RESIZE_PAGE = "page--resize";
	this.ADJUST_PAGE = "page--adjust";
	this.SHARING_PAGE = "page--share";

	this.MAX_IMAGE_WIDTH = 2048;

//--------------------------------------------
//! Vars
//--------------------------------------------
	this.sample = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAhwAAAKyAQMAAACkJpWhAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAAMhJREFUeNrtzEEBACAIBDAi2f9lJBpgB4/nFmA1ud5JbsWORCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkkp9kcr2SPAZSkgLDQBqoAAAAAElFTkSuQmCC"
 	this.currentPage = "page--landing";
 	this.dispatcher = dispatcher;

//////////////////////////////////////////////

	this.init();

//////////////////////////////////////////////

};

PageController.prototype = {

	constructor : PageController,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){

		this.bindEvents();
		this.initModalWindows();
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	bindEvents : function(){

		$(dom.navigation.next).click( this.onPageChangeNext.bindX( this ) );
		$(dom.navigation.back).click( this.onPageChangeBack.bindX( this ) );

		document.getElementById( dom.enterName.inputText.substr( 1 ) ).addEventListener( "input" , this.onInputNameChange.bindX( this ) );

		//$(dom.nextBtn).click( this.onPageChangeNext.bindX( this ) ); ///next btn

		this.dispatcher.addEventListener(EVENTS.WEBCAM_CHANGE, this.onWebCamChange.bindX( this ) );
		this.dispatcher.addEventListener(EVENTS.SCALE_RANGE_CHANGE, this.onSliderScaleUpdate.bindX( this ) );

		///share events
		$(dom.sharePage.facebook).click( this.onFacebookShare.bindX( this ) );
		$(dom.sharePage.twitter).click( this.onTwitterShare.bindX( this ) ); 
		$(dom.sharePage.download).click( this.onDownload.bindX( this ) );
		$(dom.sharePage.back).click( this.onPageChangeBack.bindX( this ) ); 
		
		//landing events
		if(Detectizr.device.type !== "desktop"){
			$(dom.landing.trailer).click(this.onTrailerClick.bindX( this ));
		}
		$(dom.landing.tickets).click(this.onTicketClick.bindX( this ));

		this.dispatcher.addEventListener(EVENTS.MODAL_VIDEO_CLOSE, this.onCloseModalVideo.bindX( this ) );

	},


	showLanding : function(back){
		if( back ){
			app.animationView.moveBackwards( $( "." +this.ENTER_NAME_PAGE ) , $("."+this.LANDING_PAGE) )
		}

		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.LANDING_PAGE_T );
		this.toggleNavBtn( false, dom.navigation.back );
		this.toggleNavBtn( true, dom.navigation.next );
		this.setPage( this.LANDING_PAGE );
		//app.animationView.moveBackwards($("."+this.ENTER_NAME_PAGE),$("."+this.LANDING_PAGE));
		//toggle text in nav button
		this.toggleNavBtn( true, dom.navigation.text_begin );
		this.toggleNavBtn( false, dom.navigation.text_continue );
		$(dom.enterName.inputText).val("")
	},

	showEnterName : function(back) {

		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.ENTER_NAME_PAGE_T );
		this.toggleUploadContainer();
		
		this.dispatcher.dispatch( EVENTS.STOP_WEBCAM );

		if(back){
			app.animationView.moveBackwards( $( "." +this.UPLOAD_PAGE ) , $("."+this.ENTER_NAME_PAGE) )
		}else{
			app.animationView.moveFoward($("."+this.LANDING_PAGE),$("."+this.ENTER_NAME_PAGE));
		}
		this.setPage( this.ENTER_NAME_PAGE );

		this.toggleNavBtn( true, dom.navigation.next );
		this.toggleNavBtn( true, dom.navigation.back );
		//toggle text in nav button
		this.toggleNavBtn( false, dom.navigation.text_begin );
		this.toggleNavBtn( true, dom.navigation.text_continue );

	},

	showUploadPage : function(  ){
		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.UPLOAD_PAGE_T );
		if( Utils.checkEmpty( $(dom.enterName.inputText).val() ) )  {
			this.showInputError( dom.errorInput.empty );
			return;
		}

		GLOBALS.name =  $(dom.enterName.inputText).val();

		if ( $( dom.errorInput.profanity ).hasClass("is-shown") ) return;

		app.animationView.moveFoward($("."+this.ENTER_NAME_PAGE),$("."+this.UPLOAD_PAGE));
		this.setPage( this.UPLOAD_PAGE );

		$(dom.canvasHolder).removeClass( "is-shown");
		this.dispatcher.dispatch( EVENTS.TOGGLERENDER , false );

		this.toggleNavBtn( true, dom.navigation.back );
		this.toggleNavBtn( false, dom.navigation.next );
	},
	
	showUploadPageBack : function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.UPLOAD_PAGE_T );
		app.uploadView.resetContinue();
		app.animationView.moveBackwards($(dom.canvasHolder),$("."+this.UPLOAD_PAGE));
		this.setPage( this.UPLOAD_PAGE );
		//$(dom.canvasHolder).removeClass( "is-shown");
		this.dispatcher.dispatch( EVENTS.TOGGLERENDER , false );
		this.toggleNavBtn( false, dom.navigation.next );

	},

	showImageEditPage : function( back ){
		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.RESIZE_PAGE_T );
		if(back){
			this.dispatcher.dispatch( EVENTS.SHOWEDITIMAGE, true );
			this.setPage(this.RESIZE_PAGE );
			return;
		}

		if( app.uploadView.checkContinue() ){
			
			app.animationView.moveFoward($("."+this.UPLOAD_PAGE),$(dom.canvasHolder));

			this.dispatcher.dispatch( EVENTS.TOGGLERENDER , true );
			this.dispatcher.dispatch( EVENTS.SHOWEDITIMAGE );

			$(dom.canvasHolder).addClass("is-shown");

			this.setPage(this.RESIZE_PAGE );

			this.toggleNavBtn( true, dom.navigation.next );

		}else{
			
			alert("cant continue");
		
		}
	},
	
	showImageAdjustPage : function( back ){
		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.ADJUST_PAGE_T );
		this.dispatcher.dispatch( EVENTS.SHOW_FILTERS , back);
		this.setPage(this.ADJUST_PAGE );
		
		if(back){
			app.animationView.moveBackwards($("."+this.SHARING_PAGE),$(dom.canvasHolder),true);
		}
		$(dom.navigation.container).css( "visibility","visible");

	},

	showFinalImagePage : function(){

		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE , this.SHARING_PAGE_T );
		$(".share__img").attr("src",this.sample);
		TweenMax.delayedCall(0.75,function(){
			this.dispatcher.dispatch( EVENTS.GENERATE_IMAGE )
		}.bindX(this))
		//
		this.setPage(this.SHARING_PAGE );
		app.animationView.moveFoward($(dom.canvasHolder),$("."+this.SHARING_PAGE));
		if(Detectizr.device.type != "desktop") app.rescaleShare();
	//	$(dom.canvasHolder).removeClass( "is-shown");
		$(dom.navigation.container).css( "visibility","hidden");
	},


	showInputError  : function( item ){

		$( dom.errorInput.empty ).removeClass( "is-shown" );
		$( dom.errorInput.profanity ).removeClass( "is-shown" );
		$(dom.enterName.inputText).removeClass('inputbox-error');
		if(item) {
			$( item ).addClass( "is-shown" );
			$(dom.enterName.inputText).addClass('inputbox-error');
		}
	},

	setCurrentPage : function( page ){

		this.currentPage = page;

	},

	toggleCurrentPage : function( show ){

		( show ) ? $( "." + this.currentPage ).addClass( "is-shown" ) : $( "." + this.currentPage ).removeClass( "is-shown" );
	
	},

	toggleNavBtn : function( show , btn ){

		( show ) ? $( btn ).addClass( "is-shown" ) : $( btn ).removeClass( "is-shown" );
	
	},

	// HIDES ALL ITEMS IN UPLOAD PREVIEW
	toggleUploadContainer : function( item ){

		$( dom.uploadPage.webCamView ).removeClass( "is-shown" );
		$( dom.uploadPage.snapView ).removeClass( "is-shown" );
		$( dom.uploadPage.picView ).removeClass( "is-shown" );
		if(item) $( item ).addClass( "is-shown" );
	
	},

	checkPageContinue : function(){

		var cont = true;
		switch( this.currentPage ){
			case "enterName" : cont = this.checkEnterName(); break;
		}		
		return cont;

	},

	checkEnterName : function(){

		//validate length
		if( $( dom.enterName.inputText ).val().length > 0 ){
			return true;
		}else{
			alert( "please type a name" );
			return false;
		}

	},
	
	setPage : function( page ){

		//this.toggleCurrentPage( false );

		this.setCurrentPage( page );

		//this.toggleCurrentPage( true );
	},

	initModalWindows : function(){
		
		if(Detectizr.device.type === "desktop"){
			$(dom.modal.trailer).modaal( { type : 'video' } );
		}
		$(dom.modal.shareErrorLink).modaal( { custom_class : 'modal-transparent' } );

		$(dom.modal.terms).modaal( {  } );

	},

	

	/*--------------------------------------------------*/
	

	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/
	
	onCloseModalVideo : function(){

		$(dom.modal.trailer).modaal( 'close' );
	},

	onPageChangeNext : function(event){
		
		switch( this.currentPage ) {
			case this.LANDING_PAGE : this.showEnterName(); break;
			case this.ENTER_NAME_PAGE : this.showUploadPage(); break;
			case this.UPLOAD_PAGE : this.showImageEditPage(false); break;
			case this.RESIZE_PAGE :  this.showImageAdjustPage(false); break;
			case this.ADJUST_PAGE :  this.showFinalImagePage(); break;
			default : break;
		}

	
	},
	
	onPageChangeBack : function (){
		switch( this.currentPage ) {
			case this.ENTER_NAME_PAGE : this.showLanding(true); break;
			case this.UPLOAD_PAGE : this.showEnterName(true); break;
			case this.RESIZE_PAGE : this.showUploadPageBack(  ); break;
			case this.ADJUST_PAGE : this.showImageEditPage( true ); break;
			case this.SHARING_PAGE : this.showImageAdjustPage( true ); break;
		}
	},

	onInputNameChange : function(e){

		var name = $(e.currentTarget).val();

		//PROFANITY
		var profanity =  Utils.checkProfanity( name );

		(Utils.checkProfanity( name ) ) ? this.showInputError( dom.errorInput.profanity ) : this.showInputError(  );
		
		//EMOJIS
		var filteredEmojis = Utils.filterAsci( name );
		$(e.currentTarget).val( filteredEmojis );
		
		//android shorten input maxLenth doesnt work on input text
		if($(e.currentTarget).val().length>10){
			var st =  $(e.currentTarget).val().substring(0,10);
			$(e.currentTarget).val(st)
		}

	},

	
	onWebCamChange : function( e , data ){
		if( data === "ON") this.toggleUploadContainer( dom.uploadPage.webCamView );
		else this.toggleUploadContainer( dom.uploadPage.snapView );
	},

	onSliderScaleUpdate : function( e , data ){

		$(dom.sliders.resizeSlider)[0].noUiSlider.updateOptions({
		range: {
			'min': data.min,
			'max': data.max
		},
		step: 0.01 
		});

	},
	
	onTrailerClick : function( e ){

		window.open( $(e.currentTarget).attr( "href" ) );
	
	},
	onTicketClick : function( e ){
		console.log(",jahsdbf,jhavf");
		window.open( $(e.currentTarget).attr( "href" ) );
	
	},
	/*--------------------------------------------------*/
	//share events
	/*--------------------------------------------------*/

	onFacebookShare : function( ){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.FACEBOOK_T );
		var blob = Utils.getBlob( $(".poster").attr("src") );
		Utils.postFacebook( blob, localisation.social.facebook.copy);

	},

	onTwitterShare : function( ){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.TWITTER_T );
		var blob = Utils.getBlob(GLOBALS.twitterImg );

		Utils.postTwitter( blob, localisation.social.twitter.copy);
	},
	
	onDownload : function( ){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.DOWNLOAD_T );
	}

};
